module.exports = __webpack_public_path__ + "img/tc8nw.ba9d3c27.png";